import { render } from "./CopyRight.vue?vue&type=template&id=b0c45118&scoped=true"
const script = {}

import "./CopyRight.vue?vue&type=style&index=0&id=b0c45118&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0c45118"]])

export default __exports__